import { OAuthIBPayload, OAuthIBResponse, portfolio } from '@api';
import { apiFetch } from '@terminal/utils/api-fetch/apiFetch';
import { httpCode } from '@terminal/utils/api-fetch/httpCode';

export const IB_OAUTH_CODE_EVENT = 'IB_OAUTH_CODE_EVENT';

export const getIBLoginLink = () =>
  apiFetch<OAuthIBResponse>(portfolio.ibLogin.path, {
    schema: portfolio.ibLogin.schema,
  });

export const postOAuthCodeIB = (data: OAuthIBPayload) =>
  apiFetch<OAuthIBPayload>(portfolio.verifyToken.path, {
    method: 'post',
    handledErrorCodes: [httpCode.badRequest],
    body: data,
  });
